import * as React from 'react';
import { Input } from 'antd';

import { BaseIcon } from '..';
import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

export const BaseInputBasic = (props) => {
  const { field, onBlur, handleChange, inputHint, type, icon, value, deletable, ...rest } = props;
  const hint = inputHint && <div className="base-input__hint">{inputHint}</div>;

  const inputSuffix = React.useCallback(() => {
    if (deletable && value) {
      return <BaseIcon icon="times" small onClick={() => handleChange('')} />;
    } else if (icon) {
      return <BaseIcon icon={icon} small />;
    }
  }, [deletable, value, icon, handleChange]);

  return (
    <>
      {React.createElement(type === 'password' ? Input.Password : Input, {
        ...field,
        ...rest,
        value,
        onBlur: onBlur,
        onChange: (e) => handleChange(e.target.value),
        suffix: icon && !deletable ? <BaseIcon icon={icon} small /> : inputSuffix(),
      })}
      {hint}
    </>
  );
};

export const BaseInput = BaseFormFieldWrapper(BaseInputBasic);
export default BaseInput;
